import { NgModule } from '@angular/core';
import { AiAssistantService } from './ai-assistant/services/ai-assistant.service';

@NgModule({
  providers: [AiAssistantService]
})
export class DomainInternalFacilitiesModule {}